import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation createTasksComment($taskID: ID, $text: String) {\n    createTasksComment(taskID: $taskID, text: $text)\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export var createTasksCommentMutation = gql(_templateObject());